export default __webpack_public_path__ + "locales/lv/People.json?hash=7b7598f4fd27a8b5934a65c4578ea80d";